export function request(id) {
    return {
        type: 'MARKETS_REMOVE_MULTIPLE_LIABILITIES_REQUEST',
        id
    };
}
